// extracted by mini-css-extract-plugin
module.exports = {"root":"BOBDate_root__1z-QS"};